<template>
  <a-modal
    :title="title"
    v-model="modalShow"
    width="80%"
    :footer="null"
    @cancel="close"
    destroyOnClose>
    <a-spin :spinning="spinning">
      <iframe style="width:100%;height:75vh;border:none;" :src="pdfUrl"></iframe>
    </a-spin>
  </a-modal>
</template>

<script>
import {transferNoticeDetail} from "@/api/message.js"
export default {
  components: {},
  data() {
    return {
      fileData:undefined,
      spinning:false,
      title: "转让通知",
      modalShow: false,
      expdId:undefined,
      msgTpCd:undefined,
      pdfUrl: undefined,
      msgStCd:undefined
    };
  },
  computed: {},
  methods: {
    open({title, expdId, msgTpCd, id, msgStCd}){
      this.modalShow = true;
      this.msgStCd = msgStCd;
      this.title = title;
      this.expdId = expdId;
      this.msgTpCd = msgTpCd;
      this.pdfUrl = process.env.VUE_APP_BASE_API + '/transfer/noticeDetail?expdId=' + this.expdId + '&msgTpCd=' + this.msgTpCd + '&id=' + id;
    },
    close(){
      this.modalShow = false;
      if(+this.msgStCd == 0){
        this.$store.dispatch("home/getMessageCount");
      }
    },
    getInfo(){
      this.spinning = true;
      transferNoticeDetail({
        expdId:this.expdId,
        msgTpCd:this.msgTpCd
      }).then(res => {
        this.fileData = res;
        this.spinning = false;
      }).catch(res => {
        this.fileData = res;
        this.spinning = false;
      })
    }
  },
  created() {},
  mounted() {},
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/message/transferNotice/pdf-view.vue